import { Typography } from "@packages/ds";
import styled, { css } from "styled-components";

import * as Table from "ds/Table";

const __layout_style = css`
  display: grid;
  align-items: center;
  grid-template-columns: 275fr 246fr 264fr 151fr 150fr;

  &:hover {
    box-shadow: unset;
  }
`;

export const TableThead = styled(Table.Thead)`
  ${__layout_style}
  padding: 20px 24px;
`;

export const TableTbody = styled(Table.Tbody)`
  margin-bottom: unset;
`;

export const RightTableTh = styled(Table.Th)`
  margin-left: auto;
`;

export const TableTr = styled(Table.Tr)`
  ${__layout_style}
  padding: 14px 24px;
  height: unset;
`;

export const OrderDetailTableTr = styled(Table.Tr)`
  ${__layout_style}
  grid-template-columns: repeat(2, 1fr);
  margin: 0 24px;
  padding: 14px 0;
  height: unset;
`;

export const TotalTableTr = styled(TableTr)`
  grid-template-columns: repeat(2, 1fr);
  padding: 20px 9px;
  margin: 23px 24px;
  background-color: var(--mode-bg-primary-weakest);
  height: unset;
`;
export const RightTableTd = styled(Table.Td)`
  margin-left: auto;
`;
export const Hr = styled.hr`
  background-color: var(--mode-border-neutral-weakest);
  margin: 0 24px;
  display: none;
`;

export const ProductName = styled(Typography.BodyText)`
  display: flex;
  align-items: center;
`;
